import { DocumentIsogd } from "isogd-document-rest";

class DocumentRequestViewController {
    private document: DocumentIsogd;
}

export const DocumentRequestViewComponent: angular.IComponentOptions = {
    controller: DocumentRequestViewController,
    template: require('./documentRequestView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-request/documentRequestView.ts